import React from 'react'
import { Icon } from 'src/stories/atoms/Icon'
import { IconName } from 'src/components/atoms/StyledIcon'
import { Theme } from 'src/styles/Theme'
import { Button, ButtonProps } from 'src/stories/atoms/Button'

export type ButtonWithIcon = ButtonProps & {
  iconName: IconName
  iconColor?: keyof Theme['iconColors']
  /**
   * loading フラグ
   */
  isLoading?: boolean
}
/**
 * アイコンとボタン
 */
export const ButtonWithIcon: React.VFC<ButtonWithIcon> = ({
  isSmall = false,
  type = 'button',
  iconName,
  iconColor,
  children,
  isLoading,
  ...props
}) => {
  const disabled = props?.disabled || isLoading
  return (
    <Button {...{ ...props, isSmall, type, disabled }}>
      <Icon
        name={iconName}
        color={iconColor}
        size={isSmall ? '14px' : '16px'}
        style={children ? { marginRight: '0.3em' } : {}}
        isLoading={isLoading}
      />
      {children}
    </Button>
  )
}
